import type { ReactNode } from 'react';
import { AccessDeniedPage } from '@/pages/AccessDeniedPage';
import { useSession } from './session.store';

/**
 * Route guard (BR-18.22, TDD §9.4 lớp 2): chặn deep-link và điều hướng từ thông báo đẩy.
 * Thiếu quyền → màn hình từ chối truy cập có đường về Trung tâm vận hành, không phải trang trắng.
 */
export function RequireCapability({
  cap,
  anyOf,
  moduleCode,
  children,
}: {
  cap?: string | undefined;
  /** KOVIX-2911: qua khi có ÍT NHẤT MỘT mã (cùng nghĩa `@RequiresCapability(anyOf)` máy chủ) — vd `/files` view HOẶC manage. */
  anyOf?: readonly string[] | undefined;
  moduleCode?: string | undefined;
  children: ReactNode;
}) {
  const status = useSession((s) => s.status);
  const ok = useSession(
    (s) =>
      (cap ? s.can(cap) : true) &&
      (anyOf && anyOf.length > 0 ? anyOf.some((c) => s.can(c)) : true) &&
      (moduleCode ? s.hasModule(moduleCode) : true),
  );
  if (status !== 'ready') return null;
  if (!ok) return <AccessDeniedPage capability={cap ?? anyOf?.join(' | ')} moduleCode={moduleCode} />;
  return <>{children}</>;
}
